import { logHelper } from '@eltoro-ui/helpers'

const logUrl = '' // empty until we known the log serivice url
const env = process.env.NODE_ENV
export const logger = logHelper(env, 'none', logUrl)

export const browserLog = logHelper(env, 'browser', logUrl)

export const terminalLog = logHelper(env, 'terminal', logUrl)
